module.exports = __webpack_public_path__ + "static/media/lisandro_martinez.20b611d3.jpg";